// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"d30c0ab5","43":"9ba37967","81":"d30c0ab5","972":"20bd1e71"}[chunkId] + ".chunk.css";
};